import './App.css';
import { Routes, Route } from "react-router-dom"
import Navbar from './components/Navbar copy';
import Dashboard from './pages/Dashboard';
import Marketplace from './pages/Marketplace';
import Transaction from './pages/Transaction';
import Wallet from './pages/Wallet';
import Profile from './pages/Profile';
import Favourite from './pages/Favourite';
import Help from './pages/Help';
import BuyElectricity from './pages/BuyElectricity';
import BecomeAseller from './pages/BecomeAseller';
import EnergyForm from './pages/EnergyForm';
import Energy from './pages/Energy';
import SignUp from './pages/sign-up';
import SignIn from './pages/sign-in';
import ResetPassword from './pages/ResetPassword';
import ForgetPassword from './pages/ForgetPassword';
import NavFooter from './components/NavFooter';



function App() {

  return (
    <>
      <Navbar />

      <Routes>
        <Route exact path="/marketplace" element={<Marketplace />} />
        <Route exact path="/help-center" element={<Help />} />
        <Route exact path="/sign-up" element={<SignUp />} />
        <Route exact path="/sign-in" element={<SignIn />} />
        <Route exact path="/reset-password" element={<ResetPassword />} />
        <Route exact path="/forget-password" element={<ForgetPassword />} />

        {/* <Route element={<PrivateRoute />}> */}
        <Route exact path="/" element={<Dashboard />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/transaction" element={<Transaction />} />
        <Route exact path="/wallet" element={<Wallet />} />
        <Route exact path="/favourites" element={<Favourite />} />
        <Route exact path="/buy-electricity/:id" element={<BuyElectricity />} />
        <Route exact path="/become-a-seller" element={<BecomeAseller />} />
        <Route exact path="/add-energy" element={<EnergyForm />} />
        <Route exact path="/energy" element={<Energy />} />
        {/* </Route> */}
      </Routes>

      <NavFooter />
    </>
  );
}

export default App;
